import styled from '@emotion/styled';
import { shouldForwardProps } from '../../helpers';
import { theme } from '../../design-system';

const StyledTextArea = ({ ...props }) => {
  const { customPropsObj } = shouldForwardProps(props);
  return {
    backgroundColor: '#fbfbfb',
    borderRadius: '8px',
    border: '1px solid #d6e4ec',
    minWidth: '300px',
    minHeight: '175px',
    color: theme.colors.neutralDark,
    autofocus: true,
    padding: '1rem',
    fontFamily: 'Verdana',
    ...customPropsObj,
  };
};

export const TextArea = styled('textarea')(StyledTextArea);
